import React from 'react';
import Seo from '../components/Seo';
import { HOW_A_JOB_WORKS } from '../data/howAJobWorks';
import { webPageJsonLd } from '../data/pageSchema';
import './HowItWorksPage.css';

const HowItWorksPage = () => {
  const page = HOW_A_JOB_WORKS;

  return (
    <div className="how-job">
      <Seo
        title={page.title}
        description={page.description}
        path={page.path}
        jsonLd={webPageJsonLd(page)}
      />
      <header className="how-job-hero">
        <div className="hero-bg-lines" aria-hidden="true" />
        <div className="how-job-hero-content">
          <div className="hero-eyebrow">Example screens</div>
          <h1>{page.h1}</h1>
          <p>{page.intro}</p>
        </div>
      </header>
      <ol className="how-job-steps">
        {page.steps.map((step) => (
          <li key={step.n} className="how-job-step">
            <h2>
              <span className="how-job-n">{step.n}</span>
              {step.title}
            </h2>
            <p>{step.text}</p>
            <img src={step.src} alt={step.alt} />
          </li>
        ))}
      </ol>
      <footer className="how-job-notes">
        {page.notes.map((note) => (
          <p key={note}>{note}</p>
        ))}
      </footer>
    </div>
  );
};

export default HowItWorksPage;
